
import React from "react";
import Typewriter from "typewriter-effect";

function Type() {
  return (
    <Typewriter
      options={{
        strings: [
          "Cybersecurity Engineer",
          "Security Researcher",
          "Vulnerability Research & Exploit Development",
          "Penetration Tester",
          "Security Tool Developer",
          "Building Practical Security Labs",
        ],
        autoStart: true,
        loop: true,
        deleteSpeed: 40,
        delay: 60,
      }}
    />
  );
}

export default Type;
